<template>
  <div>
    <Navbar @desktopNavigate="navigateBackToMode" />
    <div class="notif-wrapper">
      <div class="spacer"></div>
      <!-- <BasicNotificationCard />
      <BasicNotificationCard /> -->

      <!-- <div class="notifcations-group" v-for="(group,index) in groups" :key="index">
        <h5 class="line">
          <span>{{ formatGroupDate(group.date) }}</span>
        </h5>

        <div class="group-entity" v-for="(item,index) in group.entities" :key="index">
          <ReservationCard :reservation="item.entity" v-if="item.type == 'reservation'" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import ReservationCard from "@/components/notifications/ReservationCard.vue";
import BasicNotificationCard from "@/components/notifications/BasicNotificationCard.vue";

import moment from "moment";

export default {
  components: {
    Navbar,
    ReservationCard,
    BasicNotificationCard,
  },
  mounted() {
    this.$store.dispatch(`reserve/fetchReservations`);
  },
  methods: {
    formatGroupDate(raw) {
      const now = moment();
      const then = moment(raw);

      if (now.isSame(then, "day")) return "Сьогодні";
      if (now.subtract(1, "day").isSame(then, "day")) return "Вчора";

      return then.format("DD.MM");
    },
    navigateBackToMode(mode) {
      this.$router.push({
        name: "orders",
        query: {
          m: mode,
        },
      });
    },
  },
  computed: {
    reservations() {
      return this.$store.state.reserve.list;
    },
    groups() {
      //Create groups of notifications so we can display
      //so we can display line with time between them
      let groups = [];

      if (!this.reservations.length) return [];

      let current = moment(this.reservations[0].created_at);
      let current_group = {
        date: current.toDate(),
        entities: [],
      };

      for (let i = 0; i < this.reservations.length; i++) {
        const new_current = moment(this.reservations[i].created_at);

        if (!new_current.isSame(current, "day")) {
          current = new_current;

          groups.push(current_group);

          current_group = {
            date: new_current.toDate(),
            entities: [],
          };
        }

        current_group.entities.push({
          type: "reservation",
          entity: this.reservations[i],
        });
      }

      groups.push(current_group);

      return groups;
    },
  },
};
</script>


<style scoped>
* {
  padding: 0;
  margin: 0;
}

.notif-wrapper {
  background: #ededed;
  width: 100%;
  height: 100vh;
  overflow: auto;
  position: relative;
}

.spacer {
  height: 10vh;
}

h5.line {
  text-align: center;
  width: 100%;
  border-bottom: 1px solid #a4a3a1;
  line-height: 0.1em;
  margin: 2.5vh 0;
}
h5.line span {
  background: #ededed;
  margin: -1vh 0;
  color: #a4a3a1;
  display: inline-block;
  padding: 0 1vh;

  font-size: 2vh;
  line-height: 1;
  align-self: center;
  color: #a4a3a1;
}

@media screen and (min-width: 768px) {
  .notif-card {
    width: 38vh;
  }
  .spacer {
    height: 0;
  }
  h5.line {
    margin-top: 5vh;
  }
}
</style>